import React from 'react';
import { connect } from 'react-redux';
import Modal from '../index';
import Input from '../../Input';
import s from './style.css';
import Loading from '../../Loading';
const InputModal = ({ visible, setVisible, title, done, cancel, doneText, onChange, value, placeholder, loading, }) => {
    return (React.createElement(Modal, { visible: visible, setVisible: setVisible, cancel: cancel },
        React.createElement("div", { className: s.container },
            React.createElement("div", { className: s.titleContainer },
                React.createElement("p", { className: s.title }, title)),
            React.createElement(Input, { placeholder: placeholder || 'Folder name..', autoFocus: true, width: '20vw', onChange: onChange, value: value }),
            loading ? (React.createElement(Loading, { white: true })) : (React.createElement("div", { className: s.buttonsContainer },
                React.createElement("button", { type: 'button', className: s.button, onClick: () => {
                        setVisible(false);
                        cancel?.();
                    } }, "Cancel"),
                React.createElement("button", { type: 'submit', className: s.button, onClick: done }, doneText))))));
};
const mapStateToProps = (state) => ({
    loading: state.progress.loading,
});
const connector = connect(mapStateToProps);
export default connector(InputModal);
